import React, { useEffect, useState } from "react";
import Card from "@/components/Card";
import { useRootSelector } from "@/infrastructure/hooks";
import { api, serverUrl } from "@/infrastructure/api";
import { BacktestSel } from "@/features/backtest";
import { Progress, Typography } from "antd";
import { AxiosResponse } from "axios";

type Props = {
  taskId: string;
  datetime: string;
};

export default ({ taskId, datetime }: Props) => {
  const [progress, setProgress] = useState(0);
  const isBacktestError = useRootSelector(BacktestSel.isBacktestError);
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(isBacktestError);
    !isBacktestError && setProgress(0);
  }, [isBacktestError]);

  useEffect(() => {
    const progressTask = setInterval(fetchProgress, 1000);
    error && clearInterval(progressTask)
    return () => clearInterval(progressTask);
  }, [error]);

  return (
    <Card>
      <Progress percent={progress} status={error ? "exception" : undefined} />
      {error ? (
        <Typography.Text type={"danger"}>
          Unable to complete backtesting due to server error. Please try again...
        </Typography.Text>
      ) : (
        <Typography.Text> Backtesting started on {datetime}.</Typography.Text>
      )}
    </Card>
  );

  async function fetchProgress() {
    const { data }: AxiosResponse<number> = await api.get(`${serverUrl}/api/backtest/progress/${taskId}`);
    data < 0 ? setError(true) : setProgress(data);
  }
};
